import { toast as sonnerToast } from "sonner";

import { getApiErrorMessage } from "@/shared/lib/http-errors";

/**
 * Wrapper delgado sobre sonner con helpers idiomáticos.
 * Consumo típico:
 *   toast.success("Guardado ✓");
 *   toast.error(err);
 */
export const toast = {
  success: (message: string) => sonnerToast.success(message),
  info: (message: string) => sonnerToast.info(message),
  warning: (message: string) => sonnerToast.warning(message),
  error: (input: string | unknown) =>
    sonnerToast.error(typeof input === "string" ? input : getApiErrorMessage(input)),
  loading: (message: string) => sonnerToast.loading(message),
  dismiss: sonnerToast.dismiss,
  promise: sonnerToast.promise,
};
